import { render, staticRenderFns } from "./discount-info.vue?vue&type=template&id=39dcc3c4&scoped=true&"
import script from "./discount-info.vue?vue&type=script&lang=ts&"
export * from "./discount-info.vue?vue&type=script&lang=ts&"
import style0 from "./discount-info.vue?vue&type=style&index=0&id=39dcc3c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dcc3c4",
  null
  
)

export default component.exports